/**
 * "Tenés un borrador sin terminar." One dialog, every wizard door.
 *
 * Continuing touches nothing. "Empezar de cero" is the ONLY path that discards
 * the draft and its captured files. Back / Esc / backdrop close it and destroy
 * nothing — that is why onDismiss is wired to the safe close and not to onCancel,
 * which here is the destructive action.
 */
import { useTranslation } from 'react-i18next'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'

interface ResumeDraftDialogProps {
  visible: boolean
  /** Continue the existing draft. */
  onResume: () => void
  /** Throw the draft away (state AND files) and start clean. */
  onStartOver: () => void
  /** Back / Esc / backdrop: close without touching the draft. */
  onDismiss: () => void
  /** Distinguish the entry point in E2E. */
  testIDPrefix: string
}

export function ResumeDraftDialog({
  visible,
  onResume,
  onStartOver,
  onDismiss,
  testIDPrefix,
}: ResumeDraftDialogProps) {
  const { t } = useTranslation()
  return (
    <ConfirmDialog
      visible={visible}
      title={t('hosting.resume_draft_title')}
      message={t('hosting.resume_draft_body')}
      confirmLabel={t('hosting.resume_draft_continue')}
      cancelLabel={t('hosting.resume_draft_start_over')}
      destructive={false}
      onConfirm={onResume}
      onCancel={onStartOver}
      onDismiss={onDismiss}
      testIDs={{
        overlay: `${testIDPrefix}.resume-draft-dialog`,
        confirm: `${testIDPrefix}.resume-draft-continue`,
        cancel: `${testIDPrefix}.resume-draft-start-over`,
      }}
    />
  )
}
